export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_00.e6963f8e.jpg";